import { useValidationYupSenha, useValidationYupSenhaConfirmacao } from 'utils/form-validations';
import * as Yup from 'yup';

export const useFormConviteValidation = () => {
    const { senhaYup } = useValidationYupSenha()
    const { senhaConfirmacaoYup } = useValidationYupSenhaConfirmacao()

    const FormConviteYupValidation = Yup.object().shape({
        senha: senhaYup(),
        confirmarSenha: senhaConfirmacaoYup('senha'),
    });

    return {
        FormConviteYupValidation
    }
}

